const doc = [({"en":({"js":({"components":({"schools":({"typeahead":({"school_with_no_name":"School with no name"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;